(function () {
  var sticky = document.querySelector('[data-listicle-sticky]');
  var timerNodes = document.querySelectorAll('[data-listicle-timer]');
  var storyVideo = document.querySelector('[data-listicle-story-video]');
  var storageKey = 'cabn-listicle-sale-end';
  var cycle = 12 * 60 * 60 * 1000;

  function updateSticky() {
    if (!sticky) return;
    var scrollable = document.documentElement.scrollHeight - window.innerHeight;
    var progress = scrollable > 0 ? window.scrollY / scrollable : 0;
    var visible = progress >= 0.55;
    sticky.classList.toggle('is-visible', visible);
    sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }


  function loadStoryVideo() {
    if (!storyVideo || storyVideo.dataset.loaded === 'true') return;

    var sourceUrl = storyVideo.dataset.videoSrc;
    if (!sourceUrl) return;

    var video = document.createElement('video');
    video.controls = true;
    video.playsInline = true;
    video.preload = 'metadata';
    video.volume = 1;
    video.poster = 'https://cdn.shopify.com/s/files/1/0717/1463/5855/files/cabn-listicle-video-poster-48s.jpg?v=1787725508';
    video.setAttribute('aria-label', 'Cabn customer story');

    var source = document.createElement('source');
    source.src = sourceUrl;
    source.type = 'video/mp4';
    video.appendChild(source);

    storyVideo.dataset.loaded = 'true';
    storyVideo.replaceChildren(video);
    video.play();
  }

  function getEndTime() {
    var end = Number(localStorage.getItem(storageKey));
    var now = Date.now();
    if (!end || end <= now) {
      end = now + cycle;
      localStorage.setItem(storageKey, String(end));
    }
    return end;
  }

  var endTime = getEndTime();

  function updateTimer() {
    var remaining = endTime - Date.now();
    if (remaining <= 0) {
      endTime = Date.now() + cycle;
      localStorage.setItem(storageKey, String(endTime));
      remaining = cycle;
    }
    var hours = Math.floor(remaining / 3600000);
    var minutes = Math.floor((remaining % 3600000) / 60000);
    var seconds = Math.floor((remaining % 60000) / 1000);
    var output = String(hours).padStart(2, '0') + 'h ' + String(minutes).padStart(2, '0') + 'm ' + String(seconds).padStart(2, '0') + 's';
    timerNodes.forEach(function (node) { node.textContent = output; });
  }

  window.addEventListener('scroll', updateSticky, { passive: true });
  window.addEventListener('resize', updateSticky);
  if (storyVideo) {
    storyVideo.querySelector('button').addEventListener('click', loadStoryVideo);
  }
  updateSticky();
  updateTimer();
  window.setInterval(updateTimer, 1000);
})();
